import { MailLabelStateEnum } from "../enums/mail-label-state.enum";
import { OstSubEstadoRawEnum } from "../enums/ost-sub-estado-raw.enum";
import { isCorreosPilotStore } from "../../../utils/carrier-store.util";
import { OstMailLabelsResponse } from "../ost-mail-labels-response.model";
import { OstResponse } from "../ost-response.model";

export enum LabelCellKindEnum {
  EMPTY = "EMPTY",
  PENDING = "PENDING",
  RETRY = "RETRY",
  ERROR = "ERROR",
  NUMBER = "NUMBER",
}

export interface ILabelCell {
  kind: LabelCellKindEnum;
  trackingNumber?: string;
  labelId?: string;
}

const PENDING_STATES: string[] = [MailLabelStateEnum.PENDING];
const RETRYABLE_STATES: string[] = [MailLabelStateEnum.FAILED, MailLabelStateEnum.RETRYING];
const LABEL_WARRANTY_CODES: string[] = ["GL", "GPR"];
const LABEL_CARRIER = "CORREOS";
const OPEN_OST_STATE = "ABIERTA";

export function isLabelExpected(ost: Partial<OstResponse>, permittedStores: string[] = []): boolean {
  const isOpen = (ost.ostEstado ?? "").toUpperCase() === OPEN_OST_STATE;
  const isAtDispatch = ost.ostSubestado === OstSubEstadoRawEnum.PRODUCTO_CON_GUIA;
  const hasF11 = Number(ost.f11Num) > 0;
  const isPermittedStore = isCorreosPilotStore(permittedStores, ost.ostLocal);
  const hasLabelWarranty = LABEL_WARRANTY_CODES.includes((ost.prodTipoGarantiaCode ?? "").toUpperCase());
  const isCarrierCorreos = (ost.f11NombreTransportista ?? "").toUpperCase().includes(LABEL_CARRIER);
  const hasExpectedState = isPermittedStore ? isOpen && hasF11 : isOpen && isAtDispatch;

  return hasExpectedState && hasLabelWarranty && isCarrierCorreos;
}

export function getLastMailLabel(mailLabels?: OstMailLabelsResponse[]): OstMailLabelsResponse | undefined {
  if (!mailLabels?.length) {
    return undefined;
  }

  return [...mailLabels].sort((a: OstMailLabelsResponse, b: OstMailLabelsResponse) => Date.parse(a.fechaGeneracion ?? "") - Date.parse(b.fechaGeneracion ?? "")).at(-1);
}

export function buildLabelCell(mailLabels?: OstMailLabelsResponse[], etiquetaCreada?: boolean, labelExpected?: boolean): ILabelCell {
  const mailLabel = getLastMailLabel(mailLabels);

  if (!mailLabel) {
    if (etiquetaCreada) {
      return { kind: LabelCellKindEnum.PENDING };
    }

    return { kind: labelExpected ? LabelCellKindEnum.RETRY : LabelCellKindEnum.EMPTY };
  }

  const state = mailLabel.states;
  const base = { trackingNumber: mailLabel.trackingNumber, labelId: mailLabel.id };

  if (RETRYABLE_STATES.includes(state)) {
    return { ...base, kind: labelExpected === false ? LabelCellKindEnum.ERROR : LabelCellKindEnum.RETRY };
  }

  if (state === MailLabelStateEnum.ERROR) {
    return { ...base, kind: LabelCellKindEnum.ERROR };
  }

  if (PENDING_STATES.includes(state) || !mailLabel.trackingNumber) {
    return { ...base, kind: LabelCellKindEnum.PENDING };
  }

  return { ...base, kind: LabelCellKindEnum.NUMBER };
}
